import React, { FC, useEffect, useState } from 'react';
import { TextArea, Flex, Text, Divider, Heading } from '@adobe/react-spectrum';
import { Vector3 } from '@babylonjs/core/Maths/math';
import find from 'lodash/find';

import { I3DComment, IComment, UiHoverPoints } from '~/Scene/Ui/uiHoverPoints';
import { _system, _engine, _contentsManager } from '~/Services/Studio/studioScene';
import { getRandomString } from '~/Utils/math';
import '../../Scene/Ui/ui.sass';
import { Deletable } from '~/Components/Delete/deletable';

let uiHoverPoints: UiHoverPoints;
let currentHoveredComment: I3DComment;

const today = new Date();
const yesterday = new Date();
yesterday.setDate(today.getDate() - 1);

const beforeYesterday = new Date();
beforeYesterday.setDate(today.getDate() - 3);

const Comments: FC = () => {
    const [comments, setComments] = useState<I3DComment[]>([]);

    useEffect(() => {
        const { sceneContainer } = _engine;
        
        const cuirAgneau: IComment = {
            id: getRandomString(),
            author: 'Amy',
            date: yesterday,
            point: new Vector3(0.1335, 0.9615, 0.2190),
            text: 'The blue should be more light',
        };
        const size: IComment = {
            id: getRandomString(),
            author: 'Jack',
            date: beforeYesterday,
            point: new Vector3(0.1109, 0.2326, 0.3386),
            text: 'The pedal is supposed to be lower by 1 cm',
        };
        uiHoverPoints = new UiHoverPoints(_system, sceneContainer, [cuirAgneau, size]);
        setComments(uiHoverPoints.comments)

        _contentsManager.listenEvent(true)
        _system.canvas.addEventListener('dblclick', (e) => {
            const test = _system.pick(e);
            if (test.hit) {
                const newComment = {
                    id: getRandomString(),
                    author: 'Amy',
                    date: new Date(),
                    point: test.pickedPoint,
                    text: '',
                }
                uiHoverPoints.addPoint(newComment)
                setComments([...uiHoverPoints.comments])
            }
        });
    }, []);

    const onCommentChange = (commentId: string, text: string) => {
        const comment: I3DComment = find(comments, (c) => c.id === commentId)
        comment.followPoint.setText(text)
    }

    const onCommentDelete = (commentId: string) => {
        uiHoverPoints.removePoint(commentId)
        setComments([...uiHoverPoints.comments])
    }

    const onCommentHovered = (commentId: string) => {
        if (commentId) {
            const comment: I3DComment = find(comments, (c) => c.id === commentId)
            comment.followPoint.showAnim()
            currentHoveredComment = comment
        } else if (currentHoveredComment) {
            currentHoveredComment.followPoint.hideAnim()
            currentHoveredComment = null
        }
    }

    return (
        <Flex direction="column" gap="size-200">
            <Heading level={4} marginBottom="size-0"  marginTop="size-0">Product E2235674987: Bathroom waste can</Heading>
            {/* <TextArea
                key={getRandomString()}
                width="100%"
                label='General Comment'
                value=''
            /> */}
            <Divider/>
            {comments.map((hp) => {
                return <Deletable
                    title='comment'
                    onDelete={() => {onCommentDelete(hp.id)}}
                    key={hp.id}
                 >
                    <div
                        onMouseEnter={() => onCommentHovered(hp.id)}
                        onMouseLeave={() => onCommentHovered(null)}
                    >
                        <Flex direction="column" gap="size-100">
                            <Text UNSAFE_className="naker-hover-author">{`@${hp.author} - ${hp.date.toLocaleDateString()}`}</Text>
                            <TextArea
                                width="100%"
                                defaultValue={hp.text || ''}
                                onChange={(v) => onCommentChange(hp.id, v)}
                            />
                        </Flex>
                    </div>

                </Deletable>
            })}
        </Flex>
    );
};

export default Comments;
